import { Component } from 'vue-property-decorator';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
export { Component as VueType } from 'vue-tsx-support';
export { Component } from 'vue-property-decorator';
